import {
  CAMPAIGN as CAMPAIGN_ENUM,
  MARKUP,
  CAMPAIGN
} from "../../../../../constants/Define";
import { find, toArray } from "lodash";

export const getPromotionCampaignFromCampaign = campaign => {
  const {
    ExPromotionEmails,
    ExPromotionMemberShipTypes,
    IsExtendPromotion,
    ExEmailSuffix,
    translate
  } = campaign || {};
  const { promotionExtended } = translate || {};
  let promotionCampaign = {};
  if (promotionExtended) {
    const {
      name: pcDisplayName,
      shortDescription: pcDescription,
      detailDescription: pcDetail,
      avatarUrl: pcAvatar,
      thumbnailUrl: pcCover,
      labelWording: pcLableWording,
      ctaName: pcCtaName
    } = promotionExtended || {};
    promotionCampaign = {
      ...promotionCampaign,
      pcDisplayName,
      pcDescription,
      pcDetail,
      pcAvatar,
      pcCover,
      pcLableWording,
      pcCtaName
    };
  }
  //pcDisplayTarget
  let pcDisplayTarget = [];
  if (ExPromotionMemberShipTypes && ExPromotionMemberShipTypes.length) {
    const selectedTargets = Object.keys(CAMPAIGN.MEMBER_SHIP_TYPE).filter(f =>
      ExPromotionMemberShipTypes.includes(f)
    );
    pcDisplayTarget =
      selectedTargets &&
      selectedTargets.map(key => CAMPAIGN.MEMBER_SHIP_TYPE[key].id);
  }
  promotionCampaign = {
    ...promotionCampaign,
    pcDisplayTarget: pcDisplayTarget,
    pcEmailSuffix: ExEmailSuffix,
    pcEmails: ExPromotionEmails
  };
  return {
    promotionCampaign,
    isLoyaltyPromotion: !IsExtendPromotion
  };
};

export const getCreateType = campaign => {
  let productType =
    campaign && campaign.productType && campaign.productType.length > 0
      ? campaign.productType[0]
      : "";
  productType = (productType === "TOUR" || productType === "VINWONDER") ? "SKU" : productType
  let createType = undefined;
  if (
    toArray(MARKUP.CAMPAIGN_TYPE).filter(type => type.id === productType)
      .length > 0
  ) {
    createType = CAMPAIGN_ENUM.CREATE_TYPE["MARKUP"];
    campaign.discountMode = "ALL";
  } else {
    createType = find(
      toArray(CAMPAIGN_ENUM.CREATE_TYPE),
      type => type.id === productType.toLowerCase()
    );
  }
  return createType;
};

const parseBudget = value => {
  const budget = Number(`${value}`.replace(/,/g, ""));
  return Number.isFinite(budget) ? budget : null;
};

export const isTotalBudgetValid = (totalBudget, budgetUsed = 0) => {
  if (totalBudget === null || totalBudget === undefined || totalBudget === "") {
    return true;
  }

  const parsedTotalBudget = parseBudget(totalBudget);
  const parsedBudgetUsed = parseBudget(budgetUsed) ?? 0;
  return parsedTotalBudget !== null && parsedTotalBudget >= parsedBudgetUsed;
};

export const isPositiveIntegerOrEmpty = value => {
  if (value === null || value === undefined || value === "") {
    return true;
  }
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0;
};
